export default "__VITE_ASSET__Br67PWPK__"